var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.498901 12.5511V15.0844C0.498901 15.3178 0.682235 15.5011 0.915568 15.5011H3.4489C3.55723 15.5011 3.66557 15.4594 3.74057 15.3761L12.8406 6.28444L9.71557 3.15944L0.623901 12.2511C0.540568 12.3344 0.498901 12.4344 0.498901 12.5511ZM15.2572 3.86777C15.5822 3.54277 15.5822 3.01777 15.2572 2.69277L13.3072 0.742773C12.9822 0.417773 12.4572 0.417773 12.1322 0.742773L10.6072 2.26777L13.7322 5.39277L15.2572 3.86777Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImg);
export default __webpack_public_path__ + "static/media/editImg.1156c0c054ee33c8214ae9449aa462d1.svg";
export { ForwardRef as ReactComponent };